import React from "react";
import BlockUi from '@availity/block-ui';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//import Loader from "react-loader-spinner";
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import RFQDetailComponent from "./RFQDetailComponent";
import "./RFQ.scss";
import qs from "qs";

const dataState = {
  take: 10,
  skip: 0,
};

class RFQGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: -1,
      gridData: [],
      dataState: dataState,
    };
  }

  componentDidMount() {

    if (this.props.data == undefined) this.setState({ gridData: [] });
    else this.setState({ gridData: this.props.data });

    if (typeof this.props.location !== "undefined") {
      if (typeof this.props.location.search !== "undefined") {
        // If the user redirects from email links
        // Parse the url and get RFQ no
        const RFQNum = qs.parse(this.props.location.search, {
          ignoreQueryPrefix: true,
        }).RFQ_NUMBER;

        // If the navigation from Email links taking RFQ no from link
        // Filter that RFQ
        if (RFQNum) {
          this.setState({
            dataState: {
              ...this.state.dataState,
              filter: {
                filters: [
                  {
                    field: "rfqNum",
                    operator: "contains",
                    value: RFQNum,
                  },
                ],
                logic: "and",
              },
            },
          });
        }
      }
    }
  }

  expandChange = (event) => {
    let newData = this.state.gridData.map((item) => {
      if (item.rfqNum === event.dataItem.rfqNum) {
        item.expanded = !event.dataItem.expanded;
      } else {
        item.expanded = false;
      }
      return item;
    });

    this.setState({
      gridData: newData,
    });
  };

  render() {
    var getGridData = this.props.data;

    const grid = (
      <Grid
        ScrollMode="scrollable"
        style={{ height: "600px", width: 'auto'}}
        pageable={true}
        sortable
        filterable
        data={process(this.state.gridData, this.state.dataState)}
        {...this.state.dataState}
        onDataStateChange={(e) => {
          this.setState({ dataState: e.dataState });
        }}
        ref={(grid) => {
          this._grid = grid;
        }}
        //
        detail={({ dataItem }) => (
          <RFQDetailComponent
            dataItem={dataItem}
            onAcceptNcreateQuotationClicked={
              this.props.onAcceptNcreateQuotationClicked
            }
          />
        )}
        expandField="expanded"
        onExpandChange={this.expandChange}
        // data = {authData}
        // data = {this.state.gridData}
      >
        <GridColumn
          field="statusName"
          title="RFQ Status"
          filter="text"
          width="150px"
        />
        <GridColumn
          field="rfqNum"
          title="RFQ Number"
          filter="text"
          width="180px"
        />

        <GridColumn
          field="rfqDuedate"
          title="Quotation Due Date"
          filter="text"
          width="200px"
        />
        <GridColumn
          field="foNum"
          title="Request ID"
          filter="text"
          width="150px"
        />

        <GridColumn
          field="freightOrderDisplayStatus"
          title="Request Status"
          filter="text"
          width="150px"
        ></GridColumn>
        <GridColumn
          field="sourceAddr"
          title="Ship From"
          filter="text"
          width="220px"
          // cell={(props)=>(

          // this.props.data.map(function (comment){

          //     return (<td><p>{comment.sourceAddr.split('¿')}</p></td>);
          // })

          //  )}
          cell={(props) => (
            <td>
              {props.dataItem.sourceAddr.split("¿").map((comment) => (
                <>
                  {comment}
                  <br />
                </>
              ))}
            </td>
          )}
        ></GridColumn>
        <GridColumn
          field="destAddr"
          title="Ship To"
          filter="text"
          width="220px"
          cell={(props) => (
            <td>
              {props.dataItem.destAddr.split("¿").map((comment) => (
                <>
                  {comment}
                  <br />
                </>
              ))}
            </td>
          )}
        ></GridColumn>
        <GridColumn
          field="srcStopDatetime"
          title="Request Pickup Date"
          filter="text"
          width="200px"
        ></GridColumn>
        <GridColumn
          field="destStopDatetime"
          title="Request Delivery Date"
          filter="text"
          width="200px"
        ></GridColumn>
      </Grid>
    );

    return (
      <div>
        <MDBContainer fluid>
          <MDBRow>
            <div className="" id="kendoGrid">
              {grid}
            </div>
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}

export default RFQGrid;
